/* eslint-disable no-underscore-dangle */
import get from 'lodash/get';

export const TOOLTIP_VERTICAL_LINE = {
  beforeDraw(chart) {
    if (
      !get(
        chart,
        'config.data.customOptions.tooltip.showVerticalLine',
        false,
      ) ||
      !get(chart, 'tooltip._active.length', false) ||
      !chart.options.tooltips.enabled
    ) {
      return;
    }
    const { x } = chart.controller.tooltip._active[0].tooltipPosition();
    const { ctx } = chart;
    const yAxisName = Object.keys(chart.scales).find(axis =>
      axis.startsWith('y-axis'),
    );
    const { bottom } = chart.scales[yAxisName];

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x, 100);
    ctx.lineTo(x, bottom + 2);
    ctx.lineWidth = 0.5;
    ctx.strokeStyle = '#e5e5e5';
    ctx.stroke();
    ctx.restore();
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/plugins/tooltip.js